/* eslint-disable */
// @ts-nocheck
import * as Types from '@xing-com/crate-common-graphql-types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetSsAvailableJobsLoggedOutQueryVariables = Types.Exact<{
  recoType?: Types.InputMaybe<Types.RecommendationType>;
}>;

export type GetSsAvailableJobsLoggedOutQuery = {
  __typename?: 'Query';
  dreamJobsFetchSearchSwipeRecommendation?: {
    __typename?: 'DreamJobsCollection';
    total: number;
    collection: Array<
      | {
          __typename: 'AvailableJob';
          id: string;
          availableJobUrn?: string | null;
          availableJobTrackingToken?: string | null;
          job?:
            | { __typename: 'UnauthorizedJob' }
            | {
                __typename: 'VisibleJob';
                slug: string;
                title: string;
                refreshedAt: string;
                paid: boolean;
                visibleJobId: string;
                employmentType?: {
                  __typename?: 'EmploymentType';
                  localizationKey: string;
                  localizationValue: string;
                } | null;
                companyInfo: {
                  __typename?: 'JobCompanyInfo';
                  companyNameOverride: string;
                  company?: {
                    __typename: 'Company';
                    companyName?: string | null;
                    entityPageId?: string | null;
                    entityPage?: {
                      __typename?: 'EntityPage';
                      id: string;
                      slug: string;
                      coverImage?: Array<{
                        __typename?: 'ScaledImage';
                        url?: string | null;
                      }> | null;
                    } | null;
                    industry?: {
                      __typename?: 'Industry';
                      localizationValue: string;
                    } | null;
                    logos?: {
                      __typename?: 'CompanyLogos';
                      logo256px?: string | null;
                    } | null;
                    address?: {
                      __typename?: 'CompanyAddress';
                      city?: string | null;
                    } | null;
                    kununuData?: {
                      __typename?: 'CompanyKununuData';
                      companyProfileUrl?: string | null;
                      ratingCount?: number | null;
                      ratingAverage?: number | null;
                    } | null;
                    aboutUsBatched?:
                      | {
                          __typename: 'AboutEntity';
                          aboutHeadline?: string | null;
                          aboutSummary?: string | null;
                        }
                      | { __typename: 'EntityPageError' }
                      | null;
                  } | null;
                };
                salary?:
                  | {
                      __typename: 'Salary';
                      amount?: number | null;
                      currency?: Types.Currency | null;
                    }
                  | {
                      __typename: 'SalaryEstimate';
                      minimum?: number | null;
                      maximum?: number | null;
                      median?: number | null;
                      currency?: Types.Currency | null;
                    }
                  | {
                      __typename: 'SalaryRange';
                      minimum?: number | null;
                      maximum?: number | null;
                      currency?: Types.Currency | null;
                    }
                  | { __typename: 'SalaryUnauthorized' }
                  | null;
              }
            | null;
        }
      | { __typename: 'OccupiedJob' }
      | { __typename: 'TakenJob' }
      | null
    >;
  } | null;
};

export const GetSsAvailableJobsLoggedOutDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSsAvailableJobsLoggedOut' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'recoType' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'RecommendationType' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'dreamJobsFetchSearchSwipeRecommendation',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'recoType' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'recoType' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'collection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'AvailableJob' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'availableJobUrn' },
                              name: { kind: 'Name', value: 'urn' },
                            },
                            {
                              kind: 'Field',
                              alias: {
                                kind: 'Name',
                                value: 'availableJobTrackingToken',
                              },
                              name: { kind: 'Name', value: 'trackingToken' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'job' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: '__typename' },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: {
                                        kind: 'Name',
                                        value: 'VisibleJob',
                                      },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          alias: {
                                            kind: 'Name',
                                            value: 'visibleJobId',
                                          },
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'slug' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'title',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'refreshedAt',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'employmentType',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'localizationKey',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'localizationValue',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'paid' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'companyInfo',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'companyNameOverride',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'company',
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: '__typename',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'companyName',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'entityPageId',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'entityPage',
                                                      },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value: 'id',
                                                            },
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value: 'slug',
                                                            },
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value:
                                                                'coverImage',
                                                            },
                                                            arguments: [
                                                              {
                                                                kind: 'Argument',
                                                                name: {
                                                                  kind: 'Name',
                                                                  value:
                                                                    'dimensions',
                                                                },
                                                                value: {
                                                                  kind: 'ObjectValue',
                                                                  fields: [
                                                                    {
                                                                      kind: 'ObjectField',
                                                                      name: {
                                                                        kind: 'Name',
                                                                        value:
                                                                          'height',
                                                                      },
                                                                      value: {
                                                                        kind: 'IntValue',
                                                                        value:
                                                                          '300',
                                                                      },
                                                                    },
                                                                    {
                                                                      kind: 'ObjectField',
                                                                      name: {
                                                                        kind: 'Name',
                                                                        value:
                                                                          'reference',
                                                                      },
                                                                      value: {
                                                                        kind: 'StringValue',
                                                                        value:
                                                                          'handheld',
                                                                        block: false,
                                                                      },
                                                                    },
                                                                    {
                                                                      kind: 'ObjectField',
                                                                      name: {
                                                                        kind: 'Name',
                                                                        value:
                                                                          'width',
                                                                      },
                                                                      value: {
                                                                        kind: 'IntValue',
                                                                        value:
                                                                          '1200',
                                                                      },
                                                                    },
                                                                  ],
                                                                },
                                                              },
                                                            ],
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value:
                                                                      'url',
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'industry',
                                                      },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value:
                                                                'localizationValue',
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'logos',
                                                      },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value:
                                                                'logo256px',
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'address',
                                                      },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value: 'city',
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'kununuData',
                                                      },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value:
                                                                'companyProfileUrl',
                                                            },
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value:
                                                                'ratingCount',
                                                            },
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value:
                                                                'ratingAverage',
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'aboutUsBatched',
                                                      },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value:
                                                                '__typename',
                                                            },
                                                          },
                                                          {
                                                            kind: 'InlineFragment',
                                                            typeCondition: {
                                                              kind: 'NamedType',
                                                              name: {
                                                                kind: 'Name',
                                                                value:
                                                                  'AboutEntity',
                                                              },
                                                            },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value:
                                                                      'aboutHeadline',
                                                                  },
                                                                },
                                                                {
                                                                  kind: 'Field',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value:
                                                                      'aboutSummary',
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'salary',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'JobSalary',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JobSalary' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobSalary' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Salary' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SalaryRange' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'minimum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maximum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SalaryEstimate' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'minimum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maximum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'median' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSsAvailableJobsLoggedOutQuery,
  GetSsAvailableJobsLoggedOutQueryVariables
>;
